import { createIcon } from '../utils';

export const ClockRewindAltIcon = createIcon(
  ({ ref, className, width, height, ...rest }) => (
    <svg
      ref={ref}
      className={className}
      width={width}
      height={height}
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M20.4 11.2031L18.4006 9.20312L16.4 11.2031M18.7 9.70312C18.7 14.6737 14.6706 18.7031 9.70001 18.7031C4.72945 18.7031 0.700012 14.6737 0.700012 9.70312C0.700012 4.73256 4.72945 0.703125 9.70001 0.703125C13.0019 0.703125 15.8885 2.48126 17.4545 5.13222M9.70001 4.70312V9.70312L12.7 11.7031"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  { displayName: 'ClockRewindAltIcon' },
);
